import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MatchStepperForm from './stepper/MatchStepperForm.js';
import { Box, Typography } from '@mui/material';

const stepLabels = [
    'Informations générales'
  ]


const MatchPopupCreator = ({open, setOpen, stepInfos, setStepInfos, handleConfirm, handleCancel}) => {

    const [activeStep, setActiveStep] = React.useState(0);

    const [skipped, setSkipped] = React.useState(new Set());

    const isStepSkipped = (step) => {
        return skipped.has(step);
      };
    
      const handleClose = () => {
        setOpen(false);
      };

      const handleReset = () => {
        setActiveStep(0);
      };

      const isStepCompleted = (step) => {
        return stepInfos.isComplete[step];
      }
    
      const handleNext = () => {
        if(!isStepCompleted(activeStep))
          return
    
    
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
    
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      };
    
      const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };

    return (
        <Dialog open={open} fullWidth maxWidth={"lg"}>
            <DialogTitle align="center">CREATION D'UN MATCH</DialogTitle>
            <DialogContent>
                    <MatchStepperForm 
                    stepInfos={stepInfos} 
                    setStepInfos={setStepInfos}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    stepLabels={stepLabels}
                    skipped={skipped}
                    setSkipped={setSkipped}
                    />
            </DialogContent>
            <DialogActions sx={{justifyContent : 'space-between'}}>
            {activeStep === stepLabels.length ? (
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Reset</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2}}>
                    <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                    >
                    Précédent
                    </Button>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button onClick={handleNext} disabled={!isStepCompleted(activeStep)}>
                    {activeStep === stepLabels.length - 1 ? undefined : 'Suivant'}
                    </Button>
                </Box>
            )}


                <Box>
                    <Button onClick={handleCancel}>ANNULER</Button>
                    <Button onClick={() => {setActiveStep(0); handleConfirm()}} disabled={stepInfos.isComplete.some(v => !v)}>ENREGISTRER LE MATCH</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default MatchPopupCreator